<lms-modal #modal centered="true" className="fullHeight">
  <div class="gl-popup__scroll">
    <div class="gl-popup__close" (click)="closeModal()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__title gap-bottom">{{ 'students.personalizedEmail.modal.title' | translate }}</div>
    <div
      *ngIf="count > 1"
      class="gl-popup__text"
      [innerHtml]="'students.bulk.sendPersonalizedEmail' | translate : { total: count }"
    ></div>
    <div
      *ngIf="count === 1"
      class="gl-popup__text"
      [innerHtml]="'students.bulk.sendPersonalizedEmailSingle' | translate : { total: count }"
    ></div>
    <div class="gl-forms-new">
      <div class="form__group">
        <gl-input
          *ngIf="nameQuestion"
          [skeletorValueAccessor]="nameQuestion"
          [name]="'senderEmail'"
          [label]="nameQuestion.label | translate"
          [value]="nameQuestion.value"
          [placeholder]="'actions.writeHere' | translate"
          [tooltip]="'nouns.fromNameTooltip' | translate"
          [mandatory]="true"
          [errorMessage]="!nameQuestion.value ? ('error.required' | translate) : ''"
        >
        </gl-input>
      </div>

      <div class="form__group">
        <gl-input
          *ngIf="titleQuestion"
          [id]="'titleEmail'"
          [skeletorValueAccessor]="titleQuestion"
          [label]="titleQuestion.label | translate"
          [value]="titleQuestion.value"
          [placeholder]="'actions.writeHere' | translate"
          [mandatory]="true"
        >
        </gl-input>
      </div>
      <div class="gl-popup__link--icon" [ngClass]="{ disabledPreview: checkDisable }" (click)="preview()">
        <span class="glicon-eye"></span>
        <span>{{ 'actions.previewEmail' | translate }}</span>
      </div>
      <gl-html-editor
        [name]="'richTextEditor'"
        [label]="'actions.bodyMail' | translate"
        type="small"
        mandatory
        skeletorValueAccessor
        (onChange)="onWysiwygValueChanged($event)"
      ></gl-html-editor>
    </div>
    <div class="gl-popup__checkbox">
      <gl-checkbox
        id="checkbox"
        small="true"
        label="{{ 'actions.sendMailCopy' | translate }}"
        skeletorValueAccessor
        [(ngModel)]="isAutoSend"
      ></gl-checkbox>
    </div>
    <div class="gl-popup__buttons position-static">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="closeModal()"></gl-button>
      <gl-button
        color-primary
        [text]="'actions.sendMail' | translate"
        [disabled]="checkDisable"
        (onClick)="confirm()"
      ></gl-button>
    </div>
  </div>
</lms-modal>
